import { XmlCursorPos, XMLCursorPositions } from '../cursor/xmlCursorPos.class';
import { XmlRuleAttribut } from './xmlRuleAttribut.class';
import { XmlSchema } from './xmlSchema.class';
import { Xml2html } from '../xml-html-converter/xml2html.class';

export class XmlEditRuleCheckAttributes {
  constructor(private xmlSchema: XmlSchema) {}

  AttributesAllowedAtThisCursorPos(cursorPosToCheck: XmlCursorPos): XmlRuleAttribut[] {
    if (!cursorPosToCheck) {
      return [];
    }
    const parentNode = this.getRelevantParentNodeForCursorPos(cursorPosToCheck);
    const parentName = Xml2html.getTagNameFromNode(parentNode);
    return this.getAttributesForElementName(parentName);
  }

  getRelevantParentNodeForCursorPos(cursorPosToCheck: XmlCursorPos): Node {
    if (cursorPosToCheck) {
      let parentNode = cursorPosToCheck.ActualNode;

      switch (parentNode.nodeType) {
        case Node.COMMENT_NODE:
        case Node.TEXT_NODE:
          parentNode = parentNode.parentElement;
          break;

        case Node.ELEMENT_NODE:
          switch (cursorPosToCheck.PosAtNode) {
            case XMLCursorPositions.CursorInEmptyNode:
            case XMLCursorPositions.CursorInsideTextNode:
            case XMLCursorPositions.CursorOnCompleteNode:
              break;

            case XMLCursorPositions.CursorBehindNode:
            case XMLCursorPositions.CursorInFrontOfNode:
              parentNode = parentNode.parentElement;
              break;

            default:
              throw new Error(`unhandled cursorPosToCheck.PosAmNode "${cursorPosToCheck.PosAtNode}"/${XmlCursorPos.getXmlCursorPositionDebugName(cursorPosToCheck.PosAtNode)}" `);
          }
          break;

        default:
          throw new Error(`unhandled parentNode.nodeType "${parentNode.nodeType}"`);
      }
      return parentNode;
    }
  }

  getAttributesForElementName(elementName: string): XmlRuleAttribut[] {
    const xsdNode = this.xmlSchema.findXsdNodeForTagName(elementName);
    return this.getAttributesForElement(xsdNode, new Set([xsdNode]));
  }

  getAttributesForElement(xsdNode: Node, alreadyAddedElements: Set<Node>): XmlRuleAttribut[] {
    let attributes: XmlRuleAttribut[] = [];

    if (xsdNode) {
      alreadyAddedElements.add(xsdNode);

      const childNodes = Array.prototype.slice.call(xsdNode.childNodes);

      childNodes.forEach(child => {
        if (xsdNode.nodeType === Node.ELEMENT_NODE) {
          const childElem = child as Element;
          if (childElem) {
            if (child.localName === 'attribute') {
              // is attribute
              attributes = attributes.concat([
                new XmlRuleAttribut({
                  attribName: childElem.attributes.getNamedItem('name').value,
                  required: this.isRequiredAttribute(childElem),
                  xsdRawNode: childElem,
                  fixedValues: this.getFixedValues(childElem),
                  defaultValue: this.getDefaultValue(childElem)
                })
              ]);
            } else {
              // no attribute
              if (!alreadyAddedElements.has(child)) {
                const subNodeAttributes = this.getAttributesForElement(child, alreadyAddedElements);
                attributes = attributes.concat(subNodeAttributes);
              } else {
                // Element already added
              }
            }
          }
        }
      });
    }

    return attributes;
  }

  /** the default value for this attribute */
  private getDefaultValue(childElem: Element) {
    const attrib = childElem.attributes.getNamedItem('default');
    if (attrib !== null) {
      return attrib.value;
    }
    return undefined;
  }

  /** is this attribute required? */
  private isRequiredAttribute(childElem: Element) {
    const attrib = childElem.attributes.getNamedItem('use');
    const value = attrib !== null && attrib.value === 'required';
    return value;
  }

  /** get the allowes values for this attribute */
  private getFixedValues(xsdNode: Element, alreadyChecked: Node[] = []): string[] {
    let values: string[] = [];

    const childNodes = Array.prototype.slice.call(xsdNode.childNodes);
    childNodes.forEach(child => {
      if (xsdNode.nodeType === Node.ELEMENT_NODE) {
        const childElem = child as Element;
        if (childElem) {
          if (child.localName === 'enumeration') {
            values = values.concat([childElem.attributes.getNamedItem('value').value]);
          } else {
            // no attribute
            if (alreadyChecked.indexOf(child) === -1) {
              const subNodeAttributes = this.getFixedValues(child, alreadyChecked);
              values = values.concat(subNodeAttributes);
            } else {
              // Element already added
            }
          }
        }
      }
    });

    return values;
  }
}
